import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Manifest } from 'services/action';

import { ActionDate } from './utils'

export const ActionDeparted = ({ manifest, legs, onSubmit, handleClose, loading = false }) => {
    const Dispatch = useDispatch();
    const StateForm = useSelector((state) => state?.Form);

    const $handleSubmit = async (val) => {
        const payload = {
            atd_at: val?.time,
            latitude: 0,
            longitude: 0,
        };

        const req = await Dispatch(Manifest.$depart(manifest?.id, legs?.id, payload));
        if (req?.message === 'success') {
            if (onSubmit) onSubmit();
            if (handleClose) handleClose();
        }
    }

    return (
        <>
            <ActionDate
                dateLabel="Tanggal Keberangkatan"
                timeLabel="Jam Keberangkatan"
                disabled={false}
                isLoading={loading}
                onSubmit={$handleSubmit}
                errors={StateForm?.errors?.atd_at || StateForm?.errors?.id}
                handleClose={handleClose}
            />
        </>
    )
}
